
export const chartTooltipStyle = {
  titleFont: {
    family: 'Roboto, sans-serif',
    size: '14',
    weight: 'bolder'
  },
  bodyFont: {
    family: 'Roboto, sans-serif'
  },
  footerColor: '#FFFFFFAA',
  footerFont: {
    family: 'Roboto, sans-serif',
    weight: 'normal',
    style: 'italic'
  }
}
